<template>
  <span
    :class="[
      getBadgeClasses(rolId),
      'inline-flex items-center gap-1 rounded-full font-medium',
      compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-xs'
    ]"
  >
    <span :class="compact ? 'text-[10px]' : ''">{{ getRolIcon(rolId) }}</span>
    <span v-if="!iconOnly">{{ nombre }}</span>
  </span>
</template>

<script setup>
// Props
const props = defineProps({
  rolId: {
    type: Number,
    required: true
  },
  nombre: {
    type: String,
    required: true
  },
  compact: {
    type: Boolean,
    default: false
  },
  iconOnly: {
    type: Boolean,
    default: false
  }
})

// Función para obtener el ícono del rol
const getRolIcon = (rolId) => {
  switch (rolId) {
    case 1:
      return '👑'
    case 2:
      return '🛠️'
    case 3:
      return '🧑‍💼'
    case 4:
      return '🧑‍💻'
    case 5:
      return '🧑‍🔧'
    default:
      return '👤'
  }
}

// Función para obtener las clases CSS del badge
const getBadgeClasses = (rolId) => {
  switch (rolId) {
    case 1:
      return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200'
    case 2:
      return 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
    case 3:
      return 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
    case 4:
      return 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200'
    case 5:
      return 'bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-200'
    default:
      return 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200'
  }
}
</script>